"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportTextSection = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const index_1 = tslib_1.__importDefault(require("../../../../../components/HelpBlock/index"));
const index_2 = tslib_1.__importDefault(require("../../../../../components/Textarea/index"));
const ImportTextSection = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(index_2.default, { value: props.text, onChange: (event) => props.onTextChange(event.target.value), height: "100%" }),
        props.message && React.createElement(index_1.default, null, props.message)));
};
exports.ImportTextSection = ImportTextSection;
